import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { Withdraw2FARequired } from '../../Earnings/Withdraw/Withdraw2FARequired';
import { WithdrawAvailability } from '../../Earnings/Withdraw/WithdrawAvailability';
import { WithdrawSteps } from '../Portfolio.types';
import { AddBankAccount } from './AddBankAccount';
import { ChooseBankAccount } from './ChooseBankAccount';
import { TwoFASetup } from './TwoFASetup';
import { VerificationEmail } from './VerificationEmail';
import { WithdrawFinalCheck } from './WithdrawFinalCheck';
import { WithdrawInitial } from './WithdrawInitial';
import { WithdrawSuccess } from './WithdrawSuccess';
import { getWallets } from '../../../slices/wallets-slice';

interface WithdrawProps {
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  setWithdraw: Dispatch<SetStateAction<boolean>>;
  withdrawAvailabilitySteps: number;
}

export const Withdraw = ({
  step,
  setStep,
  setWithdraw,
  withdrawAvailabilitySteps
}: WithdrawProps) => {
  const dispatch = useAppDispatch();
  const [amount, setAmount] = useState('');

  const [selected, setSelected] = useState(0);

  const { wallets } = useAppSelector((state) => state.wallets);

  const { walletSummary } = useAppSelector((state) => state.portfolio);

  useEffect(() => {
    dispatch(getWallets());
  }, [dispatch]);

  return (
    <>
      {step === WithdrawSteps.INITIAL && (
        <WithdrawInitial
          setStep={setStep}
          userWallets={wallets}
          selected={selected}
          amount={amount}
          setAmount={setAmount}
          availableBalance={walletSummary?.availableBalance || 0}
          availableUsdtToWithdraw={walletSummary?.availableUsdtToWithdraw || 0}
          withdrawAvailabilitySteps={withdrawAvailabilitySteps}
        />
      )}
      {step === WithdrawSteps.FINAL_CHECK && (
        <WithdrawFinalCheck
          setStep={setStep}
          amount={amount}
          selected={selected}
          userWallets={wallets}
          withdrawAvailabilitySteps={withdrawAvailabilitySteps}
        />
      )}
      {step === WithdrawSteps.SUCCESS && (
        <WithdrawSuccess setWithdraw={setWithdraw} />
      )}
      {step === WithdrawSteps.CHOOSE_BANK_ACCOUNT && (
        <ChooseBankAccount
          setStep={setStep}
          selected={selected}
          setSelected={setSelected}
          userWallets={wallets}
        />
      )}

      {step === WithdrawSteps.ADD_BANK_ACCOUNT && (
        <AddBankAccount setStep={setStep} />
      )}
      {step === WithdrawSteps.TWO_FA_SETUP && (
        <TwoFASetup
          setStep={setStep}
          amount={amount}
          setAmount={setAmount}
          userWallets={wallets}
          selected={selected}
          withdrawAvailabilitySteps={withdrawAvailabilitySteps}
        />
      )}
      {step === WithdrawSteps.VERIFICATION_EMAIL && (
        <VerificationEmail
          amount={amount}
          setAmount={setAmount}
          selected={selected}
          userWallets={wallets}
        />
      )}
      {step === WithdrawSteps.TWO_FA_REQUIRED && <Withdraw2FARequired />}
      {step === WithdrawSteps.AVAILABILITY && <WithdrawAvailability />}
    </>
  );
};
